module.exports = "https://r.zoocdn.com/_next/static/images/zoopla_peak2_3851-13057589dfe8605d5043e53e487bf407.jpg";